// The shell's CORE namespaces: the part of the dictionary that en.ts and ru.ts
// write inline rather than import from an area. A translated locale carries
// them in its own `core.<locale>.ts`, which its locale module spreads over the
// English, so the words stay in that locale's chunk (D-430 ruling 9).
//
// `home` is written inline in en.ts too, but its screen is the office home
// area, and it is translated with that area in areas/office/home.

import type { Dict } from "./en.js";

export const CORE_NAMESPACES = [
  "app",
  "nav",
  "login",
  "auth",
  "kind",
  "status",
  "notFound",
  "roles",
  "ref",
  "count",
  "evidence",
  "unit",
] as const;

export type CoreNamespace = (typeof CORE_NAMESPACES)[number];

/** One locale's translation of the core namespaces, key-checked against en. */
export type CoreDict = Pick<Dict, CoreNamespace>;
